import { useNavigate } from 'react-router-dom';
import { useAppStore } from '../store/appStore';
import { searchMessages } from '../utils/search';
import { formatMessageId, getDirectionLabel, getMessageTypeLabel } from '../utils/secsDataLoader';

export default function SearchResults() {
  const navigate = useNavigate();
  const { searchQuery } = useAppStore();

  const results = searchQuery ? searchMessages(searchQuery) : [];

  return (
    <div className="max-w-5xl mx-auto p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold mb-2">Search Results</h1>
        <p className="text-[var(--color-text-secondary)]">
          {results.length > 0 ? (
            <>
              Found <span className="font-semibold">{results.length}</span> result
              {results.length !== 1 ? 's' : ''} for "{searchQuery}"
            </>
          ) : searchQuery ? (
            <>No results found for "{searchQuery}"</>
          ) : (
            <>Enter a search query to find messages</>
          )}
        </p>
      </div>

      <div className="space-y-4">
        {results.map((result) => {
          const messageId = formatMessageId(result.item.stream, result.item.function);
          const direction = getDirectionLabel(result.item.direction);
          const messageType = getMessageTypeLabel(result.item.messageType);

          return (
            <div
              key={messageId}
              className="card p-6 cursor-pointer hover:shadow-md transition-shadow"
              onClick={() => navigate(`/message/${messageId}`)}
            >
              <div className="flex items-start justify-between mb-3">
                <div>
                  <h2 className="text-xl font-bold mb-1">
                    <span className="font-mono text-primary-600 dark:text-primary-400">
                      {messageId}
                    </span>
                    {' - '}
                    {result.item.name}
                  </h2>
                  <p className="text-[var(--color-text-secondary)]">
                    {result.item.description}
                  </p>
                </div>
                <div className="text-xs text-[var(--color-text-tertiary)]">
                  Score: {((1 - result.score) * 100).toFixed(0)}%
                </div>
              </div>

              <div className="flex flex-wrap gap-2">
                <span className={`badge ${messageType.color}`}>
                  {messageType.text}
                </span>
                <span className={`badge ${direction.color}`}>
                  {direction.text}
                </span>
                {result.item.relatedMessage && (
                  <span className="badge badge-primary">
                    {result.item.messageType === 'primary' ? 'Reply: ' : 'Primary: '}
                    {result.item.relatedMessage}
                  </span>
                )}
              </div>

              {result.matches && result.matches.length > 0 && (
                <div className="mt-3 pt-3 border-t border-[var(--color-border)]">
                  <div className="text-xs text-[var(--color-text-tertiary)] mb-1">
                    Matched in: {result.matches.map(m => m.key).join(', ')}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {results.length === 0 && searchQuery && (
        <div className="text-center py-12">
          <svg
            className="mx-auto w-16 h-16 text-[var(--color-text-tertiary)] mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <p className="text-[var(--color-text-secondary)]">
            No messages found. Try a different search term.
          </p>
        </div>
      )}
    </div>
  );
}
